import axios from '../axios'

// モジュール教材（リンク）登録 payload = { name, url }
const postModuleMaterialApi = async (moduleId, payload) => {
  return await axios.post(`api/lms/modules/${moduleId}/materials`, payload)
}

export default postModuleMaterialApi
